let ar = {
  translations: {
    "Birthday omen": "فأل عيد ميلاد",
    Horoscope: "ابراج",
    Palm: "كف",
    Coffee: "قهوه",
    Tarot: "التارو",
    "Animal Spirit": "روح الحیوانیه",
    WhichAnimal: "انت شبه ای حیوان",
    errorOccured: "حدث خطأ. حاول مرة اخرى",
    myFortune: "قل لی عن طالعی",
    Animal: "حیوان",
    Loading: "جار التحميل...",
    Uploading: "جارٍ التحميل ...",
    CoffeeCupGuide: "إرشادات قراءة فنجان القهوة",
    CoffeeDesc: `اقلب الكوب رأسًا على عقب على الصحن.
    فكر فينية وابدأ بالتقاط صورة داخل فنجان القهوة الخاص بك ،`,
    isNotCup: "الصورة ليست كأس!",
    Start: "ابدأ",
    Upload: "حمل",
    CancelCamera: "إلغاء الكاميرا",
    CameraPermission: "تم رفض إذن الكاميرا",
    AllowPermission: "يرجى السماح بالإذن أو تحميل صورتك",
    ChooseBirthday: "اختر عيد الميلاد الذي تريده:",
    BestFortune: "أفضل عراف",
    StepAwayFortune: "فاضل خطوة واحدة بس عشان تقدر تشاهد الطالع بتاعك",
    ContinueGoogle: "متابعه مع جوجل",
    FindSecrets: "اعثر على الأسرار الموجوده في يدك",
    isNotPalm: "الصورة ليست  صوره من کف الید!",
    ScanHand: `من خلال تقنية المسح والقراءة المتقدمة ،
    يمكن لـ Palm Reader القيام بذلك
     توقع طالعك وحبك وحياتك والعديد من الجوانب الأخرى.`,
    TakePicture: "التقط صوره",
    DeniedCamera:
      "تم رفض إذن الكاميرا أو لا يمكنك استخدام الكاميرا على هذا الجهاز",
    PalmReading: "قراته الکف",
    Birthday: "عید میلاد",
    YourIntention: "حدد نيتك ، ركز عليها ولنبدأ ",
    AboutUs: `هل ترغب في معرفة ما يخبئه لك الحظ؟ يُعد فن العرافة جزءًا مهمًا من حياتنا اليومية، سواء أدركنا ذلك أم لا. مع Best Fortune Teller، أنت في المكان المناسب! يمكنك من خلال هذا التطبيق اكتشاف ما يخبئه لك الكون خلال اليوم أو الأسبوع أو الشهر.
لا يستطيع أيٌّ منا تغيير الماضي أو المستقبل، لكن يمكننا الاستفادة من المعلومات المتاحة هنا لمعرفة إلى أين نتجه! يتيح لك التطبيق الاطلاع على توقعات برجك اليومية، وحيوانك الروحي، ودلالات يوم ميلادك، وقراءة التاروت، وقراءة الفنجان، وقراءة الكف.
`,
    AboutUsExtraTitle: "الاشتراك والشفافية",
    AboutUsExtra: `نلتزم بتقديم أسعار واضحة ومباشرة.
يمنحك الاشتراك المميز وصولًا كاملًا إلى محتوى Best Fortune Teller وميزات التتبع، مقابل:
•	8 جنيهات مصرية يوميًا لمستخدمي اتصالات.
•	10 جنيهات مصرية يوميًا لمستخدمي WE.
•	5 جنيهات مصرية يوميًا لمستخدمي أورنج.
•	تُحصَّل الرسوم مباشرةً عبر مشغّل شبكة المحمول الخاص بك لضمان سهولة الدفع وأمانه.
•	يتجدد الاشتراك تلقائيًا يوميًا.
•	باشتراكك، فإنك توافق على تحصيل الرسوم اليومية حتى تقوم بإلغاء الاشتراك.
•	لا يُشترط الالتزام بالاشتراك لمدة طويلة.
•	يمكنك إلغاء الاشتراك في أي وقت.
لإلغاء الاشتراك، أرسل الرسالة النصية التالية مجانًا:
•	مستخدمو اتصالات: أرسل «UNSUB BFT» إلى 1722.
•	مستخدمو WE: أرسل «UNSUB BFT» إلى 4041.
•	مستخدمو أورنج: أرسل «UNSUB BFT» إلى 5030.`,
    AboutUsTitle: "معلومات عنا",
    More: "اکثر",
    Less: "اقل",
    PrivacyTitle: "الخصوصية",
    Privacy: `سياسة الخصوصية
تاريخ السريان: يناير 2026
توضح سياسة الخصوصية هذه كيفية جمع Best Fortune Teller Egypt (bft-eg.com) للبيانات الشخصية للمستخدمين واستخدامها وحمايتها.
1. المقدمة
تحترم Best Fortune Teller Egypt خصوصيتك وتلتزم بحماية معلوماتك الشخصية. توضح هذه السياسة كيفية جمع البيانات واستخدامها ومشاركتها عند الوصول إلى خدمتنا الرقمية المميزة أو الاشتراك فيها عبر bft-eg.com.
تعمل Best Fortune Teller Egypt بنظام الاشتراك، بتكلفة 8 جنيهات مصرية يوميًا لمستخدمي اتصالات، و10 جنيهات مصرية يوميًا لمستخدمي WE، و5 جنيهات مصرية يوميًا لمستخدمي أورنج، وتُحصَّل الرسوم من خلال مشغّل شبكة المحمول الخاص بك. يتجدد الاشتراك تلقائيًا كل يوم، وباختيار «اشترك»، فإنك توافق على استمرار تحصيل الرسوم اليومية حتى إلغاء الاشتراك.
`,
    PrivacyExtra: `المعلومات التي نجمعها
قد نجمع أنواع البيانات التالية:
•	رقم الهاتف المحمول: نحصل على رقمك من مشغّل شبكة المحمول الخاص بك في مصر (اتصالات أو WE أو أورنج) عند تأكيد الاشتراك، لتفعيل الخدمة وتحصيل الرسوم.
•	المعلومات الشخصية: تفاصيل مثل اسمك أو عنوان بريدك الإلكتروني عندما تتواصل معنا للحصول على الدعم أو لطرح استفسارات.
•	بيانات الاستخدام: معلومات تقنية تشمل نوع المتصفح وعنوان IP وتفاصيل الجهاز وكيفية تفاعلك مع موقعنا الإلكتروني.
•	ملفات تعريف الارتباط: ملفات بيانات صغيرة تُخزَّن على جهازك لتحسين وظائف الموقع وتحليل أدائه.
3. كيفية استخدام معلوماتك
نستخدم معلوماتك للأغراض التالية:
•	تفعيل اشتراكك وإدارته.
•	تحصيل الرسوم من خلال مشغّل شبكة المحمول الخاص بك.
•	الرد على طلبات الدعم.
•	تحسين أداء الموقع وتجربة المستخدم.
•	الوفاء بالمتطلبات القانونية والتنظيمية.
4. الاحتفاظ بالبيانات
نحتفظ بالبيانات الشخصية فقط للمدة اللازمة لتقديم الخدمة وإدارة الفوترة وتسوية النزاعات والامتثال للقوانين المعمول بها.
5. أمن البيانات
نطبق تدابير تقنية وتنظيمية مناسبة لحماية بياناتك من الوصول غير المصرح به أو التعديل أو الإفصاح أو الفقدان.
6. مشاركة المعلومات
لا نبيع بياناتك الشخصية ولا نؤجّرها. وقد تُشارَك المعلومات فقط مع:
•	مشغّلي شبكات المحمول في مصر (اتصالات أو WE أو أورنج) لتفعيل الخدمة وتحصيل الرسوم.
•	شركاء موثوقين يساعدون في تشغيل الخدمة ويلتزمون بواجبات الحفاظ على السرية.
7. حقوقك
يحق لك:
•	الاطلاع على البيانات الشخصية التي نحتفظ بها عنك.
•	طلب تصحيح بياناتك أو حذفها.
•	سحب موافقتك حيثما ينطبق ذلك.
•	إلغاء اشتراكك في أي وقت.
لممارسة هذه الحقوق، تواصل معنا عبر:
البريد الإلكتروني: contact@bft-eg.com
8. إلغاء الاشتراك
يمكنك إلغاء الاشتراك في أي وقت بإرسال رسالة نصية مجانية كما يلي:
•	مستخدمو اتصالات: أرسل «UNSUB BFT» إلى 1722.
•	مستخدمو WE: أرسل «UNSUB BFT» إلى 4041.
•	مستخدمو أورنج: أرسل «UNSUB BFT» إلى 5030.
9. نقل البيانات دوليًا
قد تُعالَج بياناتك في البلدان التي نعمل فيها أو يعمل فيها مقدّمو خدماتنا. ونضمن تطبيق ضمانات مناسبة تتوافق مع لوائح حماية البيانات المعمول بها، بما في ذلك قانون حماية البيانات الشخصية المصري (PDPPL).
10. تحديثات السياسة
قد تُحدَّث سياسة الخصوصية هذه بصورة دورية. وستكون أحدث نسخة متاحة دائمًا على bft-eg.com، مع تاريخ السريان المحدَّث.
11. تواصل معنا
لأي استفسارات تتعلق بهذه السياسة، يُرجى التواصل معنا:
البريد الإلكتروني: contact@bft-eg.com
الموقع الإلكتروني: https://bft-eg.com
`,
    TermsTitle: "البنود و الظروف",
    TermsCondition: `يخضع وصولك إلى الخدمة واستخدامك لها لقبولك هذه الشروط والتزامك بها. تنطبق هذه الشروط على جميع الأشخاص الذين يزورون الخدمة أو يصلون إليها أو يستخدمونها. باستخدامك الخدمة، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا توافق على أي جزء منها، فيجب عليك عدم استخدام الخدمة. هذه الخدمة مخصصة فقط للمستخدمين الذين تبلغ أعمارهم 18 عامًا فأكثر.`,
    TermsConditionExtra: `التوافر والأخطاء وعدم الدقة
نُحدّث منتجاتنا وخدماتنا بانتظام، ولذلك قد يتأخر ظهور بعض المحتوى أحيانًا أو يصبح غير متاح مؤقتًا أثناء إجراء التحديثات على منصتنا أو في الإعلانات الخارجية.
على الرغم من بذل جهود معقولة للحفاظ على دقة الخدمة وتحديثها، فإننا لا نضمن دقة أي معلومات أو اكتمالها أو حداثتها. ونحتفظ بالحق في تعديل المحتوى وتصحيح الأخطاء أو المعلومات الناقصة في أي وقت دون إشعار مسبق.
الاشتراكات
تُقدَّم بعض ميزات الخدمة على أساس الاشتراك. تُعد Best Fortune Teller Egypt خدمة اشتراك مميزة بتكلفة 8 جنيهات مصرية يوميًا لمستخدمي اتصالات، و10 جنيهات مصرية يوميًا لمستخدمي WE، و5 جنيهات مصرية يوميًا لمستخدمي أورنج.
يتجدد الاشتراك تلقائيًا كل يوم. باختيار «اشترك»، فإنك توافق على تحصيل الرسوم اليومية حتى تقوم بإلغاء الاشتراك. تُحصَّل الرسوم مقدمًا ضمن دورة فوترة يومية متكررة. ويتجدد اشتراكك تلقائيًا بالشروط نفسها ما لم تقم بإلغائه أو نقم نحن بإلغائه.
يمكنك إلغاء اشتراكك في أي وقت باستخدام الطريقة الموضحة أدناه.
الفوترة ومعالجة المعاملات
باعتبارنا خدمة قائمة على الاشتراك، فإننا نعالج معلومات الفوترة المتعلقة بحسابك من خلال مشغّل شبكة المحمول الخاص بك في مصر (اتصالات أو WE أو أورنج).
باشتراكك، فإنك تفوّض مشغّل شبكة المحمول الخاص بك بخصم الرسوم المقررة من رصيدك مسبق الدفع أو إضافتها إلى فاتورتك إذا كنت تستخدم نظام الدفع الآجل.
عدم وجود التزام طويل الأجل
لا يوجد أي التزام طويل الأجل. يمكنك إلغاء اشتراكك متى شئت. إذا ألغيت الاشتراك خلال فترة فوترة سارية، فسيستمر وصولك إلى الخدمة حتى نهاية تلك الفترة. بعد الإلغاء، لن يتجدد الاشتراك ولن تُفرض أي رسوم إضافية ما لم تشترك مجددًا.
باستثناء الحالات التي يقتضيها القانون، لا تُقدَّم عادةً مبالغ مستردة أو أرصدة تعويضية عن المدة غير المستخدمة أو فترات الفوترة الجزئية.
سياسة استرداد الأموال
تُراجَع طلبات استرداد الأموال بشكل فردي، وقد تتم الموافقة عليها وفقًا لتقديرنا، ما لم يقتضِ القانون المعمول به خلاف ذلك.
تحديد المسؤولية
لا تتحمل Best Fortune Teller Egypt، بما في ذلك مديروها وموظفوها وشركاؤها ووكلاؤها ومورّدوها والجهات التابعة لها، المسؤولية عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية. ويشمل ذلك، على سبيل المثال لا الحصر، خسارة الأرباح أو البيانات أو الانتفاع أو السمعة التجارية أو غيرها من الخسائر غير الملموسة الناشئة عن:
1.	استخدامك للخدمة أو عدم قدرتك على استخدامها.
2.	أي تصرفات أو محتوى صادر عن أطراف ثالثة.
3.	الوصول غير المصرح به إلى بياناتك أو تعديلها.
4.	أي مشكلات أخرى تتعلق بالخدمة.
إخلاء المسؤولية
تستخدم الخدمة على مسؤوليتك الخاصة. تُقدَّم الخدمة «كما هي» و«حسب توافرها»، دون أي ضمانات، سواء كانت صريحة أو ضمنية.
لا نضمن ما يلي:
•	أن تعمل الخدمة دون انقطاع أو أخطاء.
•	أن يتم إصلاح أي عيوب.
•	أن تلبي الخدمة توقعاتك أو متطلباتك.
إلغاء الاشتراك وسحب الموافقة على معالجة البيانات
يحق لك إيقاف معالجة البيانات في أي وقت عن طريق إلغاء اشتراكك.
لإلغاء الاشتراك، أرسل رسالة نصية مجانية كما يلي:
•	مستخدمو اتصالات: أرسل «UNSUB BFT» إلى 1722.
•	مستخدمو WE: أرسل «UNSUB BFT» إلى 4041.
•	مستخدمو أورنج: أرسل «UNSUB BFT» إلى 5030.
بمجرد إلغاء الاشتراك، سيتوقف فورًا تحصيل أي رسوم مستقبلية وأي معالجة للبيانات مرتبطة بذلك.
القانون الحاكم
تخضع هذه الشروط لقوانين جمهورية مصر العربية وتُفسَّر وفقًا لها، دون اعتبار لمبادئ تنازع القوانين.
إذا تبيّن أن أي حكم من هذه الشروط غير صالح أو غير قابل للتنفيذ، فستظل الأحكام المتبقية سارية بكامل أثرها.
تمثل هذه الشروط الاتفاق الكامل بينك وبين Best Fortune Teller Egypt، وتحل محل أي اتفاقات سابقة تتعلق بالخدمة.
التغييرات على الشروط
يجوز لنا تحديث هذه الشروط أو تعديلها في أي وقت وفقًا لتقديرنا وحدنا. ويُعد استمرارك في استخدام الخدمة بعد هذه التغييرات قبولًا منك للشروط المحدَّثة.
التواصل
إذا كانت لديك أي أسئلة حول هذه الشروط، يُرجى التواصل معنا:
البريد الإلكتروني: contact@bft-eg.com
الموقع الإلكتروني: https://bft-eg.com
© 2026 Best Fortune Teller Egypt. جميع الحقوق محفوظة.
`,
    January: "كانون الثاني",
    February: "فبراير",
    March: "مارس",
    April: "أبريل",
    May: "مايو",
    June: "يونيو",
    July: "تموز",
    August: "أغسطس",
    September: "سبتمبر",
    October: "اكتوبر",
    November: "نوفمبر",
    December: "ديسمبر",
    Logout: "تسجیل خروج",
    Login: "تسجيل الدخول",
    Unsubscribe: "إلغاء الاشتراك",
    UnsubSuccess: "لقد تم إلغاء الاشتراك بنجاح",
    UnsubFail: "فشل فی الغاء التسجیل",
    Subscribe: "الاشتراك",
    Confirm: "تؤكد",
    notSubscribed: "ليس لديك اشتراك ؟",
    resendOtp: "اعادة ارسال رمز التحقق",
    selectRegion: "اختر منطقتك",
  },
};

export default ar;
